import { render, staticRenderFns } from "./CurrentEmail.vue?vue&type=template&id=3fc89463&"
import script from "./CurrentEmail.vue?vue&type=script&lang=js&"
export * from "./CurrentEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports